'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _goals = require('redux/modules/goals');

var goalActions = _interopRequireWildcard(_goals);

var _components = require('components');

var _reactRouter = require('react-router');

var _modules = require('redux/modules/modules');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module0App5 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    app: state.moduleData.data.module0.app5,
    allModule: state.moduleData.data.module1,
    goals: state.goals.data
  };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem }, goalActions)), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module0App5, _Component);

  function Module0App5() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module0App5);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module0App5.__proto__ || (0, _getPrototypeOf2.default)(Module0App5)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 1,
      appId: 5,
      // barriers get concatenated to the barrier array
      barriers: _this.props.app.barriers || [''],
      isCompleted: _this.props.app.isCompleted || false,
      showModal: false
    }, _this.handleChange = function (barrierNumber, value) {
      var obj = _this.state;
      obj.barriers[barrierNumber] = value;
      _this.setState(obj);
    }, _this.handleAddBarrier = function () {
      var obj = _this.state;
      obj.barriers.push('');
      _this.setState(obj);
    }, _this.handleRemoveBarrier = function (index) {
      var obj = _this.state;
      obj.barriers.splice(index, 1);
      _this.setState(obj);
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }
      obj.showModal = true;
      obj.isCompleted = true;
      _this.setState(obj);

      // update the actual app
      // this.props.updateModuleApp(this.props.user.userId, this.state.moduleId, this.state.appId, this.state);
      _this.props.updateModuleApp(_this.props.user.userId, 0, 5, _this.state);

      // update the overarching module's details
      _this.props.updateModule(_this.props.user.userId, _this.state.moduleId, {
        'numAppCompleted': numAppCompleted,
        'numAppTotal': _this.props.allModule.numAppTotal });

      _this.props.updateBarriers(_this.props.user.userId, _this.state);
    }, _this.nextModule = function () {
      _this.props.changeItem(_this.state.moduleId, 0, _this.state.appId + 1);
    }, _this.close = function () {
      var obj = _this.state;
      obj.showModal = false;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * Handle text change inside barrier input field
   */


  /*
   * Adds another barrier to the front end UI
   */


  /*
   * Handle when user finishes this module
   */


  (0, _createClass3.default)(Module0App5, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Getting Ready'
            ),
            _react2.default.createElement(
              'h2',
              null,
              'What are your barriers to achieving your Reboot Kids goals?'
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'A barrier is anything that causes you to slip up in your goal to make changes.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Some barriers are the kind that stop you from even trying to change a habit. Other barriers can pop up later.'
          ),
          _react2.default.createElement(
            'h5',
            null,
            'Write down any barriers you think you might face in trying to reach your goals.'
          ),
          _react2.default.createElement(_components.SetStrategies, { type: 'barrier', handleAdd: this.handleAddBarrier, handleRemove: this.handleRemoveBarrier,
            handleChange: this.handleChange, inputfields: this.state.barriers }),
          _react2.default.createElement(
            'p',
            null,
            'We will revisit these later during the Reboot Kids program.'
          ),
          _react2.default.createElement(_components.FinishTaskButton, { complete: this.state.isCompleted, onChange: this.handleComplete }),
          _react2.default.createElement('div', { className: styles.spacer100 }),
          _react2.default.createElement(
            ReactBootstrap.Modal,
            { show: this.state.showModal, onHide: this.close },
            _react2.default.createElement(
              ReactBootstrap.Modal.Header,
              { closeButton: true },
              _react2.default.createElement(
                ReactBootstrap.Modal.Title,
                { className: styles.darkOrangeText },
                'Your barriers are set!'
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Modal.Body,
              null,
              _react2.default.createElement(
                'p',
                null,
                'You\'ve successfully set your barriers for Reboot Kids, your Profile will now contain the barriers you have just set.'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/profile' },
                  'Click here'
                ),
                ' to go to your profile.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Otherwise, press ',
                _react2.default.createElement(
                  'strong',
                  null,
                  'Return to main menu'
                ),
                ' to return to module selection.'
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Modal.Footer,
              null,
              _react2.default.createElement(
                ReactBootstrap.Button,
                { className: 'btn-success', onClick: this.nextModule },
                'Continue'
              )
            )
          )
        )
      );
    }
  }]);
  return Module0App5;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  app: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  goals: _propTypes2.default.object,
  updateModuleApp: _propTypes2.default.func,
  updateModule: _propTypes2.default.func,
  updateBarriers: _propTypes2.default.func,
  changeItem: _propTypes2.default.func
}, _temp2)) || _class);
exports.default = Module0App5;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/0/App/App5.js
// module id = 1157
// module chunks = 0